module.exports = "https://99designs-start-assets.imgix.net/js/d5b40476c42025672f8a63c37e961a3a.png";